import styled from "@emotion/styled";

import { setFullViewportWidthStyles } from "shared/lib/styles";
import { theme } from "shared/lib/styles/theme";

import { Loading } from "scmp-app/components/common/loading";

import { PlusCftContentList } from "./content-list";
import { PlusCftWebinarWidget } from "./webinar-widget";

export const Container = styled.div`
  ${setFullViewportWidthStyles()}
  margin-block-end: 40px;
  padding-block-start: 12px;
  padding-inline: 32px;

  ${theme.breakpoints.only("mobile")} {
    display: none;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  inline-size: 100%;
  max-inline-size: 1208px;
  margin: auto;
`;

export const FilterAndWebinarArea = styled.div`
  display: flex;
  gap: 40px;
  align-items: flex-start;

  margin-block-end: 32px;
`;

export const FilterTabsContainer = styled.div`
  flex: 1;
`;

export const WidgetContainer = styled.div`
  inline-size: 240px;

  ${theme.breakpoints.up("desktop")} {
    inline-size: 280px;
  }
`;

export const StyledPlusCftContentList = styled(PlusCftContentList)``;

export const StyledPlusCftWebinarWidget = styled(PlusCftWebinarWidget)``;

export const StyledLoading = styled(Loading)``;
